import { typedQueryClient, useTypedQuery } from "hooks";
import { CustomersQueryKeys } from "modules/CustomersDashboard/queryKeys";
import { CUSTOMERS_DASHBOARD_STORAGE_KEYS } from "modules/CustomersDashboard/storageKeys";
import { PAGE_SIZE, getPreference, setPreference } from "utils/common";

import type { CustomerFilters } from "modules/CustomersDashboard/queryKeys";

export const useCustomersFilters = () => {
  const filters = useTypedQuery({
    queryKey: CustomersQueryKeys.filters,
    initialData: {
      search_term: "",
      is_lease_company: getPreference(CUSTOMERS_DASHBOARD_STORAGE_KEYS.IsLeaseCompanyPreference, false),
      page: 1,
      page_size: PAGE_SIZE.PageSize25
    }
  }).data;

  return { filters };
};

export const setFilters = (updatedFilters: CustomerFilters) => {
  setPreference(CUSTOMERS_DASHBOARD_STORAGE_KEYS.IsLeaseCompanyPreference, updatedFilters.is_lease_company);

  const oldFilters = typedQueryClient.getQueryData(CustomersQueryKeys.filters);
  typedQueryClient.setQueryData(CustomersQueryKeys.filters, { ...oldFilters, ...updatedFilters });
};
